'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('../helpers/utils');

var _bind = require('../mixins/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Export esc event helper.
 */
/**
 * Mixin: Esc event
 * -----------------------------------------------------------------------------
 * Mixin to trigger events based on a global esc key event.
 *
 */
exports.default = function () {

  /**
   * Initialise component bind to prevent double binds.
   */
  var binder = (0, _bind2.default)(document.documentElement, {
    className: 'esc-bind'
  });

  /**
   * Set Esc keyboard event.
   * @param {Event} event - Keycode event set on document.
   */
  function onEscEvent(event) {
    if (!isKeyPressIsEsc(event) || !binder.isSet()) {
      return;
    }

    Frame.EventBus.emit('EscEvent:on');
    binder.remove();
  }

  /**
   * Check if Esc is pressed.
   * @param {Event} event - Keycode event passed from document.
   */
  function isKeyPressIsEsc(event) {
    return event.keyCode === 27;
  }

  /**
   * Listen for keydown events.
   */
  function setKeyDownToggleEvent() {
    if (binder.isSet()) {
      return;
    }

    (0, _utils.on)('keydown', function (event) {
      return onEscEvent(event);
    });
    binder.set();
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    set: setKeyDownToggleEvent
  });
};